import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppDispatch } from '../store';

import { FoilDataInterface, FoilReducer } from './interfaces/FoilReducer';
import { ICommentario } from '../../API/interfaces/FormularioService/ConsultaFolio';

const initialState: FoilReducer = {
  foilData: undefined,
  foilCode: undefined,
  foilKey: undefined,
};

export const foilSlice = createSlice({
  name: 'foil',
  initialState,
  reducers: {
    setFoilData: (state, action: PayloadAction<FoilDataInterface>) => {
      state.foilData = action.payload;
    },
    setFoilCode: (state, action: PayloadAction<string>) => {
      state.foilCode = action.payload;
    },
    setFoilKey: (state, action: PayloadAction<string>) => {
      state.foilKey = action.payload;
    },
    removeFoilData: state => {
      state.foilData = initialState.foilData;
    },
    removeFoilCode: state => {
      state.foilCode = initialState.foilCode;
    },
    pushAdminComment: (state, action: PayloadAction<ICommentario>) => {
      if (state.foilData?.comentarios) {
        state.foilData.comentarios.push(action.payload);
      } else if (state.foilData) {
        state.foilData.comentarios = [action.payload];
      }
    }
  },
});

export const setFoilData = async (dispatch: AppDispatch, payload: FoilDataInterface) => {
  dispatch(foilSlice.actions.setFoilData(payload));
};

export const setFoilCode = async (dispatch: AppDispatch, payload: string) => {
  dispatch(foilSlice.actions.setFoilCode(payload));
};

export const setFoilKey = async (dispatch: AppDispatch, payload: string) => {
  dispatch(foilSlice.actions.setFoilKey(payload));
};

export const removeFoilData = async (dispatch: AppDispatch) => {
  dispatch(foilSlice.actions.removeFoilData());
};

export const removeFoilCode = async (dispatch: AppDispatch) => {
  dispatch(foilSlice.actions.removeFoilCode());
};

export const pushAdminComment = async (dispatch: AppDispatch, payload: ICommentario) => {
  dispatch(foilSlice.actions.pushAdminComment(payload));
};

const foilReducer = foilSlice.reducer;
export default foilReducer;
